
































import Vue from "vue";
import ProfileHome from "@/components/ProfileHome.vue";
import Footer from "@/components/Footer.vue";

export default Vue.extend({
  name: "Home",
  components: {
    ProfileHome,
    Footer,
  },
  data: () => ({
    socials: [
      {
        icon: "mdi-whatsapp",
        tooltip: "+6285255136996",
        link: "https://wa.me/+6285255136996",
      },
      {
        icon: "mdi-google-plus",
        tooltip: "rahmanpsg014@gmail.com",
        link: "mailto:rahmanpsg014@gmail.com",
      },
      {
        icon: "mdi-instagram",
        tooltip: "@rahmanpsg",
        link: "https://www.instagram.com/rahmanpsg",
      },
      {
        icon: "mdi-github",
        tooltip: "@rahmanpsg",
        link: "https://www.github.com/rahmanpsg",
      },
      {
        icon: "mdi-linkedin",
        tooltip: "Abd Rahman",
        link: "https://www.linkedin.com/in/rahmanpsg/",
      },
    ],
  }),
});
